module.exports = __webpack_public_path__ + "img/eurekers.b9fdcd3e.jpg";